export default state => {
  return state.bootstrap.complete || false;
};
